
import SearchCard from './SearchCard.vue'
import SearchForm from './SearchForm.vue'
export default {
  components: { SearchCard, SearchForm },
  props: {
    results: {
      default: () => [],
    },
  },
}
